// extracted by mini-css-extract-plugin
export default {"body":"CreatorStoryModal_body__0S6cw","modal":"CreatorStoryModal_modal__jw-Y3"};